import { createContext } from 'react';

const FormContext = createContext({ value: "", initialValue: {} });

export { FormContext as default };
//# sourceMappingURL=contexts.js.map
